import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import { ApiStaticKey } from 'models/protocol';
import api from 'Api/ApiMethods';
import ApiKeysTable from './ApiKeysTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
  background-color: var(--surface-ground);
`;

const ApiKeys: FC = observer(() => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiKeys, setApiKeys] = useState<ApiStaticKey[]>([]);
  console.log(apiKeys);

  useEffect(() => {
    setIsLoading(true);
    const controller = new AbortController();

    api.getApiKeys(controller).then((res) => {
      setApiKeys(res);
      setIsLoading(false);
    });

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Container>
      <ApiKeysTable apiKeys={apiKeys} isLoading={isLoading} />
    </Container>
  );
});

export default ApiKeys;
